import React, { useState, useEffect, useContext } from 'react';
import Questions from 'src/pages/InsigthFactory/Questions';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import pagination from 'src/utils/pagination';
import { putScore, getQuestions } from 'src/services/questionServices';
import { swalMessages, permitsList } from 'src/constants';
import swal from 'sweetalert';
import { Context } from '../../context/Contex';

const QuestionsContainer = () => {
  const { id } = useParams();
  const history = useHistory();
  const location = useLocation();
  const { permisos } = useContext(Context);
  const permitValue = permisos[permitsList.FABRICA_INSIGHTS];
  const [postPerPage] = useState(1);
  const [form, setForm] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const { currentPosts } = pagination(questions, currentPage, postPerPage);
  const { totalPages } = pagination(questions, currentPage, postPerPage);

  const onChangeAnswer = (event, field, idQuestion) => {
    const answer = event.target.value;
    const updateQuestions = questions.map((question) => {
      if (question.id === idQuestion) {
        return {
          ...question,
          respuesta: answer,
        };
      }
      return question;
    });
    setQuestions(updateQuestions);
    setForm({ ...form, [field]: answer });
  };

  const onChangePage = (direction) => {
    if (direction === 'next') {
      setCurrentPage(currentPage + 1);
    } else {
      setCurrentPage(currentPage - 1);
    }
  };

  const onSubmitQuestions = async (e) => {
    e.preventDefault();
    const respuestas = Object.values(form);
    const questionsId = id;
    const { success, error } = await putScore({
      id: questionsId,
      tipo: 'tipo_entrada',
      respuestas,
    });
    if (success) {
      const { state } = location;
      history.push(`/insight_factory/details/${questionsId}`, state);
    } else {
      swal({
        title: error, icon: 'warning', button: 'cerrar', dangerMode: true,
      }).then(() => history.push('/insight_factory_entries_queue'));
    }
  };

  const fetchQuestions = async () => {
    const { success, data } = await getQuestions();
    if (success) {
      setQuestions(data);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const withoutPermit = (permit) => {
    if (permit < 3) {
      history.push('/insight_factory');
    } else {
      return null;
    }
  };

  useEffect(() => {
    withoutPermit(permitValue);
    fetchQuestions();
  }, []);

  return (
    <Questions
      totalPages={totalPages}
      questions={currentPosts}
      currentPage={currentPage}
      onChangePage={onChangePage}
      onChangeAnswer={onChangeAnswer}
      onSubmitQuestions={onSubmitQuestions}
    />
  );
};

export default QuestionsContainer;
